import { FindifyDataContextType } from "@/contexts/FindifyDataContext";

export class PlaceColor {
    value: string;

    constructor(value: string) {
        this.value = value;
    }


    get() {
        return this.value;
    }
    withAlpha(alpha: number): string {
        const hexStr = alpha.toString(16).padStart(2, '0');
        return this.value.length > 7 ? `${this.value.slice(0, 7)}${hexStr}` : `${this.value}${hexStr}`;
    }

    solidAlphaWhiteBase(alpha: number): string {
        // Parse the original color value
        const red = parseInt(this.value.substr(1, 2), 16);
        const green = parseInt(this.value.substr(3, 2), 16);
        const blue = parseInt(this.value.substr(5, 2), 16);

        // Calculate the equivalent solid color
        const solidRed = Math.round((red * (255 - alpha) / 255) + (255 * (alpha / 255)));
        const solidGreen = Math.round((green * (255 - alpha) / 255) + (255 * (alpha / 255)));
        const solidBlue = Math.round((blue * (255 - alpha) / 255) + (255 * (alpha / 255)));


        // Convert the solid color to hexadecimal format
        const solidHex = `#${solidRed.toString(16).padStart(2, '0')}${solidGreen.toString(16).padStart(2, '0')}${solidBlue.toString(16).padStart(2, '0')}`;

        return solidHex;
    }
    solidAlphaBlackBase(alpha: number): string {
        // Parse the original color value
        const red = parseInt(this.value.substr(1, 2), 16);
        const green = parseInt(this.value.substr(3, 2), 16);
        const blue = parseInt(this.value.substr(5, 2), 16);

        // Calculate the equivalent solid color
        const solidRed = Math.round((red * (255 - alpha) / 255) + (0 * (alpha / 255)));
        const solidGreen = Math.round((green * (255 - alpha) / 255) + (0 * (alpha / 255)));
        const solidBlue = Math.round((blue * (255 - alpha) / 255) + (0 * (alpha / 255)));


        // Convert the solid color to hexadecimal format
        const solidHex = `#${solidRed.toString(16).padStart(2, '0')}${solidGreen.toString(16).padStart(2, '0')}${solidBlue.toString(16).padStart(2, '0')}`;

        return solidHex;
    }

}

export const PlaceColors = (findifyDataContext: FindifyDataContextType | null) => {
    // console.log('findifyDataContextColor', findifyDataContext?.workspace?.app_settings)
    const isDarkmodeEnabled = findifyDataContext?.darkMode;
    const colors = findifyDataContext?.visitWorkspaceSelected ? findifyDataContext?.workspace?.app_settings?.colors : {};
    if (isDarkmodeEnabled) {
        return {
            primary: new PlaceColor(colors?.main_color_dark ?? '#21365D'),
            secondary: new PlaceColor(colors?.secondary_color_dark ?? '#417DED'),
            text: new PlaceColor(colors?.text_color_dark ?? '#FFFFFF'),
            background: new PlaceColor(colors?.background_color_dark ?? '#202020'),
            alternateListBG: new PlaceColor(colors?.alternate_list_bg_dark ?? '#00000050'),
            sidebarBackgroundColor: new PlaceColor(colors?.sidebar_background_color_dark ?? '#000000CF'),
            sidebarTextColor: new PlaceColor(colors?.sidebar_text_color_dark ?? '#000000CF'),
            bottomBar: new PlaceColor(colors?.bottom_bar_dark ?? '#000000CF'),
            bottomBarIcon: new PlaceColor(colors?.bottom_bar_icon_dark ?? '#000000CF'),
            bottomBarIconSelected: new PlaceColor(colors?.bottom_bar_icon_selected_dark ?? '#000000CF'),
            findifyPrimary: new PlaceColor('#21365D'),
            findifySecondary: new PlaceColor('#417DED'),
        }
    } else {
        return {
            primary: new PlaceColor(colors?.main_color ?? '#21365D'),
            secondary: new PlaceColor(colors?.secondary_color ?? '#417DED'),
            text: new PlaceColor(colors?.text_color ?? '#000000'),
            background: new PlaceColor(colors?.background_color ?? '#FFFFFF'),
            alternateListBG: new PlaceColor(colors?.alternate_list_bg ?? '#00000050'),
            sidebarBackgroundColor: new PlaceColor(colors?.sidebar_background_color ?? '#000000CF'),
            sidebarTextColor: new PlaceColor(colors?.sidebar_text_color ?? '#000000CF'),
            bottomBar: new PlaceColor(colors?.bottom_bar ?? '#000000CF'),
            bottomBarIcon: new PlaceColor(colors?.bottom_bar_icon ?? '#FFFFFFCF'),
            bottomBarIconSelected: new PlaceColor(colors?.bottom_bar_icon_selected ?? '#FFFFFFCF'),
            findifyPrimary: new PlaceColor('#21365D'),
            findifySecondary: new PlaceColor('#417DED'),
        }
    }
}
